import React from "react";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import AnnouncementOutlinedIcon from "@mui/icons-material/AnnouncementOutlined";
import SpeedIcon from "@mui/icons-material/Speed";
import TimerIcon from "@mui/icons-material/Timer";

const defaultStats = [
    {
      icon: VerifiedOutlinedIcon,
      iconColor: "success",
      value: "98.5%",
      label: "Success Rate",
      comparison: "↑ 1.2% from yesterday",
      comparisonType: "up",
    },
    {
      icon: AnnouncementOutlinedIcon,
      iconColor: "statsRed",
      value: "1.5%",
      label: "Failure Rate",
      comparison: "↓ 1.5% from yesterday",
      comparisonType: "down",
    },
    {
      icon: SpeedIcon,
      iconColor: "statsOrange",
      value: "2.3s",
      label: "Avg Processing Time",
      comparison: "↓ 0.3s faster",
      comparisonType: "down",
    },
    {
      icon: TimerIcon,
      iconColor: "statsBright",
      value: "45s",
      label: "Avg Message Duration",
      comparison: "-",
      comparisonType: "neutral",
    },
  ];

const TranscriptionStats = ({ stats = defaultStats }) => {

  return (
    <div className="bg-white rounded-xl shadow-sm p-6 border border-line">
      {/* Header */}
      <div className="mb-6 pb-4 border-b border-line">
        <h2 className="text-lg font-bold text-content mb-1">
          Transcription Stats
        </h2>
        <p className="text-sm text-subtle">
          Performance metrics for your transcriptions
        </p>
      </div>

      {/* Stats List */}
      <div className="space-y-6">
        {stats.map((stat, index) => (
          <div key={index} className="flex items-center justify-between">
            {/* Left side: Icon and Value/Label */}
            <div className="flex items-center gap-4 flex-1">
              {/* Icon */}
              <div
                className={`w-12 h-12 p-2 rounded-full flex items-center justify-center flex-shrink-0 border border-${stat.iconColor} bg-${stat.iconColor}/20`}
              >
                <stat.icon className={`w-5 h-5 text-${stat.iconColor}`} />
              </div>

              {/* Value and Label */}
              <div className="flex flex-col">
                <div className="text-2xl font-bold text-content">
                  {stat.value}
                </div>
                <div className="text-sm text-content">{stat.label}</div>
              </div>
            </div>

            {/* Right side: Comparison */}
            <div className="text-xs text-subtle text-right ml-4">
              {stat.comparisonType === "up" && (
                <span className="inline-flex items-center">
                  <svg
                    className="w-3 h-3 mr-1"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  {stat.comparison.replace("↑ ", "")}
                </span>
              )}
              {stat.comparisonType === "down" && (
                <span className="inline-flex items-center">
                  <svg
                    className="w-3 h-3 mr-1"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  {stat.comparison.replace("↓ ", "")}
                </span>
              )}
              {stat.comparisonType === "neutral" && (
                <span>{stat.comparison}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TranscriptionStats;
